<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>OUR Menus</h2>
                    <ul>
                        <li class="list-style-desc"><h2>{{currentRouteName + ' Menu' | titlecase}}</h2></li>
                    </ul>
                    <!-- <p class="mt-4 mb-0">Explore our menu and satisfy every craving — from cheesy pizzas to juicy burgers.</p> -->
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/logo.png" alt="Menu Page" class="img-fluid menu-logo">
            </div>
        </div>
    </div>
</div>
<section class="build-your-own-section mt-2">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <p class="title">Pick your size, crust, sauce, and toppings — from classic favorites to bold new flavors.</p>
            </div>
            <div class="col-12 text-center">
                <a href="custom-food" class="btn btn-primary px-5">Build Your Own</a>
            </div>
        </div>
    </div>
</section>

<section class="lunchSpecialMenu mt-5 mb-3" *ngIf="currentRoute == 'MainCategory'">
    <div class="container-fluid">
        <div class="row">
            <!-- Subcategories Tabs -->
            <div class="col-12 mt-3" *ngIf="subCategories && subCategories.length > 0">
                <div class="subcategory-tabs">
                    <ul class="nav nav-tabs" id="subcategoryTabs" role="tablist">
                        <li class="nav-item" *ngFor="let subCategory of subCategories; let i = index">
                            <button class="nav-link" 
                            [class.active]="activeSubCategory === subCategory.id"
                            (click)="selectSubCategory(subCategory.id)">
                                <!-- <img src="{{subCategory.avatar}}" class="itemImage" width="200" height="200" alt="{{subCategory.name}}">
                                {{subCategory.name}} -->
                                <img src="{{subCategory.avatar}}" class="itemImage" alt="{{subCategory.name}}">
                                <p class="mt-3">{{subCategory.name}}</p>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 mt-3 items">
                <div class="row">
                    <div class="col-12 text-center">
                        <div class="spinner-grow" role="status" *ngIf="isLoading">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="!isLoading">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt-5" *ngFor="let product of subCategoryProducts">
                                <div class="menu-item-card">
                                    <div class="card-image-container">
                                        <a href="product-details/{{product.id}}/{{product.name}}">
                                            <img src="{{product.avatar}}" class="card-image" alt="{{product.name}}">
                                        </a>
                                    </div>
                                    
                                    <div class="card-content">
                                        <h3 class="card-title">
                                            {{product.name}} 
                                            <label *ngIf="product.offer" class="offer-badge">{{ getOfferText(product.offer) }}</label>
                                        </h3>
                                        
                                        <p class="card-description" *ngIf="product.components">{{product.components}}</p>
                                        
                                        <div class="card-footer">
                                            <div class="price"><span *ngIf="product.show_price == 1" >{{product.types[0].price | currency}}</span></div>
                                            <div class="card-actions">
                                                <a href="product-details/{{product.id}}/{{product.name}}" class="cart-btn"> <!--(click)="selectProduct(product.id)"-->
                                                    <i class="bx bx-cart"></i>
                                                </a>
                                                <a (click)="toggleFav(product.id)" class="favorite-btn">
                                                    <i class="bx bx-heart heart" 
                                                    [class.bxs-heart]="product.isFavorite || isFavorite(product.id)" 
                                                    [class.text-danger]="product.isFavorite || isFavorite(product.id)"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" *ngIf="subCategoryProducts.length == 0">
                            <div class="alert alert-danger">
                                <strong>Oops!</strong> No Products Found
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="mainMenu mt-5 mb-3" *ngIf="currentRoute == 'Main'">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 mt-3" *ngIf="subCategories && subCategories.length > 0">
                <div class="subcategory-tabs">
                    <ul class="nav nav-tabs" id="subcategoryTabs" role="tablist">
                        <li class="nav-item" *ngFor="let subCategory of subCategories; let i = index">
                            <button class="nav-link" 
                            [class.active]="activeSubCategory === subCategory.id"
                            (click)="selectSubCategory(subCategory.id)">
                                <img src="{{subCategory.avatar}}" class="itemImage" alt="{{subCategory.name}}">
                                <p class="mt-3">{{subCategory.name}}</p>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 mt-5 items">
                <div class="row">
                    <div class="col-12 text-center">
                        <div class="spinner-grow" role="status" *ngIf="isLoading">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="!isLoading">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt-5" *ngFor="let product of subCategoryProducts">
                               <div class="menu-item-card">
                                    <div class="card-image-container">
                                        <a href="product-details/{{product.id}}/{{product.name}}">
                                            <img src="{{product.avatar}}" class="card-image" alt="{{product.name}}">
                                        </a>
                                    </div>
                                    
                                    <div class="card-content">
                                        <h3 class="card-title">
                                            {{product.name}} 
                                            <label *ngIf="product.offer" class="offer-badge">{{ getOfferText(product.offer) }}</label>
                                        </h3>
                                        
                                        <p class="card-description" *ngIf="product.components">{{product.components}}</p>
                                        
                                        <div class="card-footer">
                                            <div class="price"><span *ngIf="product.show_price == 1 && product.types[0]?.price" >{{product.types[0]?.price | currency}}</span></div>
                                            <div class="card-actions">
                                                <a href="product-details/{{product.id}}/{{product.name}}" class="cart-btn"> <!--(click)="selectProduct(product.id)"-->
                                                    <i class="bx bx-cart"></i>
                                                </a>
                                                <a (click)="toggleFav(product.id)" class="favorite-btn">
                                                    <i class="bx bx-heart heart" 
                                                    [class.bxs-heart]="product.isFavorite || isFavorite(product.id)" 
                                                    [class.text-danger]="product.isFavorite || isFavorite(product.id)"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" *ngIf="subCategoryProducts.length == 0">
                            <div class="alert alert-danger">
                                <strong>Oops!</strong> No Products Found
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt-5">
                        <div class="menu-item">
                            <a class="">
                                <i class="bx bx-heart heart"></i>
                            </a>
                            <img src="../../../../assets/img/home2/food.png" class="itemImage" width="220" alt="Images">
                            <h2>Woodfired Margherita Pizza</h2>
                            <p>Classic thin-crust pizza with fresh mozzarella and basil.</p>
                            <a class="readMore">Read more</a>
                            <div class="menu-actions text-center mt-3">
                                <button data-bs-toggle="modal" data-bs-target="#itemModalDetails" class="btn btn-primary">Order Now</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt-5">
                        <div class="menu-item">
                            <a class="">
                                <i class="bx bx-heart heart"></i>
                            </a>
                            <img src="../../../../assets/img/home2/food.png" class="itemImage" width="220" alt="Images">
                            <h2>Woodfired Margherita Pizza</h2>
                            <p>Classic thin-crust pizza with fresh mozzarella and basil.</p>
                            <a class="readMore">Read more</a>
                            <div class="menu-actions text-center mt-3">
                                <button data-bs-toggle="modal" data-bs-target="#itemModalDetails" class="btn btn-primary">Order Now</button>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</section>

<!-- that comes from home sub category icons that exists in the grid in home page -->
<section class="realMenuItems mt-3 mb-3" *ngIf="currentRoute == 'SubCategory'">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 items">
                <div class="row">
                    <div class="col-12 text-center">
                        <div class="spinner-grow" role="status" *ngIf="isLoading">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="!isLoading">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-6 col-12" *ngFor="let item of subCategoryProducts">
                                <!-- <div class="menu-container">
                                    <a (click)="toggleFav(item.id)" class="">
                                        <i class="bx bx-heart heart" [class.bxs-heart]="item.isFavorite" [class.bxs-heart.text-danger]="isFavorite(item.id)" [class.text-danger]="item.isFavorite"></i>
                                    </a>
                                    <img src="{{item.avatar}}" class="itemImage" width="200" height="200" alt="{{item.name}}">
                                    <div class="item-data w-100">
                                        <h2>{{item.name}}</h2>
                                        <p class="itemDesc ellipsis">{{item.components}}</p>
                                        <span class="price" *ngIf="item.offer && item.show_price == 1; else noOffer">
                                            <span class="original-price" *ngIf="item.offer.type === 'percentage' || item.offer.type === 'discount'">
                                                {{item.types[0].price}} $
                                            </span>
                                            <span class="price text-danger">
                                                {{ calculateDiscountedPrice(item) }} $
                                            </span>
                                            <span class="offer-badge">
                                                {{ getOfferText(item.offer) }}
                                            </span>
                                        </span>
                                        <ng-template #noOffer>
                                            <span *ngIf="item.show_price == 1" class="price">{{item.types[0].price}} $</span>
                                        </ng-template>
                                        <button class="btn btn-primary" 
                                                data-bs-toggle="modal" 
                                                data-bs-target="#itemModalDetails" 
                                                (click)="selectProduct(item.id)">
                                            Order Now
                                        </button>
                                        <span class="clear-both"></span>
                                    </div>
                                </div> -->
                                <div class="menu-item-card">
                                    <div class="card-image-container">
                                        <a href="product-details/{{item.id}}/{{item.name}}">
                                            <img src="{{item.avatar}}" class="card-image" alt="{{item.name}}">
                                        </a>
                                    </div>
                                    
                                    <div class="card-content">
                                        <h3 class="card-title">
                                            {{item.name}} 
                                            <label *ngIf="item.offer" class="offer-badge">{{ getOfferText(item.offer) }}</label>
                                        </h3>
                                        
                                        <p class="card-description" *ngIf="item.components">{{item.components}}</p>
                                        
                                        <div class="card-footer">
                                            <div class="price"><span *ngIf="item.show_price == 1 && item.types[0]?.price" >{{(item.types[0]?.price | currency) || 0}}</span></div>
                                            <div class="card-actions">
                                                <a href="product-details/{{item.id}}/{{item.name}}" class="cart-btn"> <!--(click)="selectProduct(product.id)"-->
                                                    <i class="bx bx-cart"></i>
                                                </a>
                                                <a (click)="toggleFav(item.id)" class="favorite-btn">
                                                    <i class="bx bx-heart heart" 
                                                    [class.bxs-heart]="item.isFavorite || isFavorite(item.id)" 
                                                    [class.text-danger]="item.isFavorite || isFavorite(item.id)"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="subCategoryProducts.length == 0">
                            <div class="alert alert-danger">
                                <strong>Oops!</strong> No Products Found
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<!-- Pagination Controls -->
<div class="col-12 mt-4" *ngIf="subCategoryProducts.length > 0 && totalPages > 1">
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="goToPage(currentPage - 1)" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      
      <li class="page-item" *ngFor="let page of getPagesArray()" 
          [class.active]="page === currentPage">
        <a class="page-link" (click)="goToPage(page)">{{page}}</a>
      </li>
      
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="goToPage(currentPage + 1)" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
  
  <div class="text-center text-muted mt-2" style="color: #009246;">
    Showing page {{currentPage}} of {{totalPages}} ({{subCategoryProducts.length}} of {{totalItems}} items)
  </div>
</div>


<app-footer-style-two></app-footer-style-two>